import { Tenant } from "./tenant";

export enum InvoiceProvider {
  Fortnox = "Fortnox",
  Bonliva = "Bonliva",
  BonlivaCare = "BonlivaCare",
  WCC = "WCC"
}

export function getInvoiceProviderByTenant(tenant: Tenant): InvoiceProvider {
  if (tenant === Tenant.BonlivaAB) {
    return InvoiceProvider.Fortnox;
  }
  if (tenant === Tenant.WCC) {
    return InvoiceProvider.WCC;
  }
  throw new Error(`Unsupported tenant: ${tenant}`);
}

export function getTenantByInvoiceProvider(provider: InvoiceProvider): Tenant {
  const mapping: Record<InvoiceProvider, Tenant> = {
    [InvoiceProvider.Fortnox]: Tenant.BonlivaAB,
    [InvoiceProvider.Bonliva]: Tenant.BonlivaAB,
    [InvoiceProvider.BonlivaCare]: Tenant.BonlivaAB,
    [InvoiceProvider.WCC]: Tenant.WCC
  };

  const tenant = mapping[provider];

  if (!tenant) {
    throw new Error(`Unsupported invoice provider: ${provider}`);
  }

  return tenant;
}
